import React from 'react';
import AuthProvider from '@context/auth';

import Dashboard from './Dashboard';

const DashboardWrapper = () => (
  <AuthProvider>
    <Dashboard />
  </AuthProvider>
  );

export default DashboardWrapper;
